import React from 'react';
import error from '../../assets/icons/error.png';
import closeError from '../../assets/icons/close-error.png';
import tip from '../../assets/icons/tip.png';
import closeTip from '../../assets/icons/close-tip.png';
import infoTip from '../../assets/icons/information.png';
import { ErrorCircle24Regular } from '@fluentui/react-icons';

// eslint-disable-next-line no-shadow
export enum TYPE_MESSAGE {
  TIP = 'TIP',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

interface Iprops {
  handle?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void | null;
  texte: string;
  show?: boolean;
  typeMessage: TYPE_MESSAGE;
}

export const Alert = ({
  texte,
  show,
  handle,
  typeMessage = TYPE_MESSAGE.TIP,
}: Iprops): React.ReactElement => {
  if (show) {
    return (
      <div
        className={`relative flex  break-words rounded-borderRadius10 p-4 border-none ${
          typeMessage === TYPE_MESSAGE.WARNING &&
          'bg-[#FFF1E4] text-[#BC5F0A]  '
        } ${typeMessage === TYPE_MESSAGE.TIP && 'bg-[rgb(0,105,92)]/[0.12]'} ${
          typeMessage === TYPE_MESSAGE.ERROR && 'bg-[rgb(176,0,32)]/[0.08]'
        }`}
      >
        <div className="w-5 p-0 mx-4 my-0 ">
          <div className="mb-4 p-0  rounded-full w-10 h-10 outline-none bg-transparent hover:bg-[rgb(126,121,121)]/[0.14">
            <span>
              {typeMessage === TYPE_MESSAGE.TIP && <img src={tip} alt="TIP" />}
              {typeMessage === TYPE_MESSAGE.ERROR && (
                <img src={error} alt="Error" />
              )}
              {typeMessage === TYPE_MESSAGE.WARNING && <ErrorCircle24Regular />}
            </span>
          </div>
        </div>
        <div
          className={`w-full  text-base text-start m-0 p-0 ${
            typeMessage === TYPE_MESSAGE.WARNING && ' text-[#BC5F0A] '
          } ${typeMessage === TYPE_MESSAGE.ERROR && 'text-red-50 '} ${
            typeMessage === TYPE_MESSAGE.TIP && 'text-green-50'
          }`}
        >
          <p className="mb-3 text-base font-semibold text-left ">
            {typeMessage === TYPE_MESSAGE.TIP && 'TIP'}
            {typeMessage === TYPE_MESSAGE.ERROR && 'Error'}
            {typeMessage === TYPE_MESSAGE.WARNING && 'Information'}
          </p>
          <span className="text-base">{texte}</span>
        </div>
        {handle && (
          <div className="p-0 my-0 mx-4  !mr-[1.4rem] w-5  ">
            <button
              onClick={handle}
              type="button"
              className=" mb-4 p-0  rounded-full w-10 h-10 outline-none bg-transparent hover:bg-[rgb(126,121,121)]/[0.14]  flex items-center justify-center  "
            >
              <span>
                {typeMessage === TYPE_MESSAGE.TIP ? (
                  <img src={closeTip} alt="Close Tip" />
                ) : (
                  <img src={closeError} alt="Close Error" />
                )}
              </span>
            </button>
          </div>
        )}
      </div>
    );
  }
  return <></>;
};

Alert.defaultProps = {
  show: false,
  handle: null,
};

export default Alert;
